import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactModal from 'react-modal';
import { hideModal, validateFacebookToken, setTokens, setSelfError,
    getSelf } from 'appSrc/redux/actions';
import { LoadingOverlay } from 'appSrc/components/Shards';
import LoginForm from './LoginForm';
import FacebookLoginButton from 'appSrc/components/Facebook/LoginButton';
import { XIcon } from 'appSrc/components/UI';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import style from './styles/style.module.css';

ReactModal.setAppElement( '#root' );

class LoginModal extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: false,
        };
    }
    onWorking = () => {
        this.setState( { fetching: true } );
    }
    attemptFacebookLogin = ( fbObj ) => {
        this.setState( { fetching: true } );
        this.props.validateFacebookToken( fbObj )
        .then( ( response ) => {
            if( response.statusMessage == 'UserDoesNotExist' ) {
                //the user doesn't exist, redirect to registration
                alert( 'No such user' );
                // this.props.router.history.push( '/app/register/user/' );
                this.props.closeModal();
            } else {
                //the user does exist, and we just got their token info, so log them in
                this.props.setTokens( response.tokens );
                this.props.getSelf()
                .then( ( self ) => {
                    Mixpanel.identify( self.userid );
                    Mixpanel.track( 'userLoggedIn' );
                } );
                if( /\/app\/register\//.test( window.location.pathname ) ) {
                    this.props.router.history.push( '/' );
                } else {
                    this.props.router.history.goBack();
                }
                this.props.closeModal();
            }
        } );
    }
    render() {
        const { modalName, modalProps } = this.props;
        const isOpen = modalName === 'loginModal' && modalProps.modalIsOpen;
        const message = modalProps.message || 'WELCOME BACK';
        // const createAccountMessage = modalProps.createAccountMessage || 'CREATE ONE';
        // const createAccountLink = modalProps.toCreator ? '/app/register/pro/' : '/app/register/user/';

        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel='Login'
            onRequestClose={ this.props.closeModal }
            className={ `modal-popup ${ style.loginModal }` }
            overlayClassName='modal-overlay' >
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <div className={ style.loginFormWrapper } data-hook='login-modal'>
                    <div className={ style.formTitle }>
                        <h3>{ message }</h3>
                    </div>

                    <LoginForm closeModal={ this.props.closeModal } onWorking={ this.onWorking } />

                    <div className={ style.forgotPasswordWrapper }>
                        <Link className={ style.forgotPassword }
                        to="/app/forgot-password"
                        onClick={ this.props.closeModal } >FORGOT PASSWORD?</Link>
                    </div>

                    <p className={ style.emailBreak }>or</p>

                    <FacebookLoginButton onSubmit={ this.attemptFacebookLogin } />

                    {/*<div className={ style.forgotPasswordWrapper }>
                        <p>No account yet? <Link
                        className={ style.forgotPassword }
                        to={ createAccountLink }
                        onClick={ this.props.closeModal } >{ createAccountMessage }</Link></p>
                    </div>*/}
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}


const mapStateToProps = ( state ) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
        router: state.router,
        facebookStatus: state.facebook.status,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        closeModal: () => {
            dispatch( hideModal( 'loginModal' ) );
            dispatch( setSelfError( null ) );
        },
        validateFacebookToken: ( data ) => {
            return dispatch( validateFacebookToken( data ) );
        },
        setTokens: ( tokens ) => {
            dispatch( setTokens( tokens ) );
        },
        getSelf: ( ) => {
            return dispatch( getSelf() );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( LoginModal );
